import { useState } from "react";
import { motion } from "framer-motion";
import { Play, Star, Film } from "lucide-react";
import { imageUrl } from "@/lib/xtream";
import FavoriteButton from "@/components/FavoriteButton";

export default function MovieCard({ item, onClick, kind = "movie", index = 0, creds }) {
  const [errored, setErrored] = useState(false);
  const cover = kind === "movie" ? item.stream_icon : item.cover;
  const src = cover && !errored ? imageUrl(cover) : null;
  const rating = item.rating ? parseFloat(item.rating) : null;

  return (
    <motion.div
      data-testid={kind === "movie" ? "movie-card" : "series-card"
      }
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: Math.min(index * 0.03, 0.4) }}
      onClick={onClick}
      role="button"
      tabIndex={0}
      className="group text-left w-full cursor-pointer"
    >
      <div className="relative aspect-[2/3] rounded-xl overflow-hidden bg-[#131924] border border-white/5 transition-all duration-300 ease-out group-hover:scale-105 group-hover:-translate-y-1 group-hover:border-[#14A3FF]/50 group-hover:shadow-2xl group-hover:shadow-red-950/40">
        {creds ? (
          <span onClick={(e) => e.stopPropagation()}>
            <FavoriteButton creds={creds} kind={kind} item={item} />
          </span>
        ) : null}
        {src ? (
          <img
            src={src}
            alt={item.name}
            loading="lazy"
            onError={() => setErrored(true)}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-slate-700">
            <Film className="h-10 w-10" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="h-11 w-11 rounded-full bg-[#14A3FF] flex items-center justify-center shadow-[0_0_18px_rgba(20,163,255,0.6)]">
            <Play className="h-5 w-5 text-white fill-white" />
          </div>
        </div>
        {rating ? (
          <div className="absolute top-2 right-2 flex items-center gap-1 rounded-md bg-black/70 backdrop-blur px-1.5 py-0.5 text-[11px] font-semibold text-[#E5A93C]">
            <Star className="h-3 w-3 fill-[#E5A93C]" /> {rating.toFixed(1)}
          </div>
        ) : null}
      </div>
      <h3 className="mt-2 text-sm font-medium text-slate-200 line-clamp-1 group-hover:text-white transition-colors">
        {item.name}
      </h3>
      {item.year || item.releaseDate ? (
        <p className="text-xs text-slate-500">{item.year || (item.releaseDate || "").slice(0, 4)}</p>
      ) : null}
    </motion.div>
  );
}
